import { Button } from '../Button/Button';
import './Dropdown.css';

/** Footer bar for a Dropdown panel with Clear and Apply action buttons. */
export type DropdownFooterProps = {
  clearLabel?: string;
  applyLabel?: string;
  onClear?: () => void;
  onApply?: () => void;
  clearDisabled?: boolean;
  applyDisabled?: boolean;
  className?: string;
};

export function DropdownFooter({
  clearLabel = 'Clear',
  applyLabel = 'Apply',
  onClear,
  onApply,
  clearDisabled = false,
  applyDisabled = false,
  className = '',
}: DropdownFooterProps) {
  return (
    <div
      className={['spark-dropdown-footer', className].filter(Boolean).join(' ')}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <Button
        variant="tertiary"
        size="small"
        fill
        type="button"
        disabled={clearDisabled}
        className="spark-dropdown-footer-btn"
        onClick={onClear}
      >
        {clearLabel}
      </Button>
      <Button
        variant="secondary"
        size="small"
        fill
        type="button"
        disabled={applyDisabled}
        className="spark-dropdown-footer-btn"
        onClick={onApply}
      >
        {applyLabel}
      </Button>
    </div>
  );
}
